import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { onSnapshot, query, where, collection, orderBy, getFirestore } from 'firebase/firestore';
import { vacationRequestService } from '../../services/vacationRequestService';
import type { VacationRequest } from '../../models/vacation.types';

export const VACATION_REQUESTS_QUERY_KEY = 'vacationRequests';

export function useMyVacationRequestsQuery(email?: string) {
    const queryClient = useQueryClient();
    const db = getFirestore();

    useEffect(() => {
        if (!email) return;

        const q = query(
            collection(db, 'vacationRequests'),
            where('collaboratorEmail', '==', email),
            orderBy('requestedAt', 'desc')
        );

        const unsubscribe = onSnapshot(
            q,
            (snap) => {
                const requests = snap.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                } as VacationRequest));
                queryClient.setQueryData([VACATION_REQUESTS_QUERY_KEY, email], requests);
            },
            () => {}
        );

        return () => unsubscribe();
    }, [email, queryClient, db]);

    const queryResult = useQuery({
        queryKey: [VACATION_REQUESTS_QUERY_KEY, email],
        queryFn: () => vacationRequestService.getByCollaboratorEmail(email as string),
        enabled: Boolean(email),
        staleTime: Infinity,
    });

    return {
        requests: queryResult.data ?? [],
        isLoading: queryResult.isLoading,
        error: queryResult.error,
    };
}
